import { RemoteDataUtils } from '@assetmark/ui-kit/dist/utils/remote-data.utils';
import { fromNullable } from 'fp-ts/lib/Option';
import { LeadApi } from '../../apis/lead.api';
import { withRxJs } from '../../components/hoc/with-rx';
import { GetStarted } from './get-started.component';

export const GetStartedContainer = withRxJs(GetStarted)(() => {
	const pageSetting$ = LeadApi.pageSetting$;

	let screenSize: any = '';
	if (window.innerWidth <= 992 && window.innerWidth >= 577) {
		screenSize = 'Medium';
	} else if (window.innerWidth <= 576) {
		screenSize = 'Small';
	} else {
		screenSize = 'Large';
	}

	const images$ = LeadApi.getStartedImages(screenSize);
	
	const imagesUrl$ = RemoteDataUtils.combineLatestRD(pageSetting$, images$).mapRD(([selectedImage, images]) => {
		return {
			imageUrl1: fromNullable(
				images.find(img => img.index.getOrElse(0) === selectedImage.image1)?.imageUri.getOrElse(''),
			),
			imageUrl2: fromNullable(
				images.find(img => img.index.getOrElse(0) === selectedImage.image2)?.imageUri.getOrElse(''),
			),
		};
	});

	return {
		defaultProps: {
			images: RemoteDataUtils.initial,
			pageSetting: RemoteDataUtils.initial,
			imagesUrl: RemoteDataUtils.initial,
		},
		props: {
			images: images$,
			pageSetting: pageSetting$,
			imagesUrl: imagesUrl$,
		},
	};
});
